<template>
  <b-nav-item-dropdown
    class="dropdown-cart mr-25"
    menu-class="dropdown-menu-media"
    right
    @show="fetchItems"
  >
    <template #button-content>
      <feather-icon
        :badge="$store.state['app-p'].cartItemsCount"
        class="text-body"
        icon="ShoppingCartIcon"
        size="21"
      />
      
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
            Properties
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >
          {{ $store.state['app-p'].cartItemsCount }} Items
        </b-badge>
      </div>
    </li>

    <!-- Cart Items -->
    <vue-perfect-scrollbar
      v-if="items.length"
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <b-media
        v-for="item in items"
        :key="item.name"
      >
        <template #aside>
          <b-img
          v-if="item.property_images[0]"
            :src="item.property_images[0].fullfilepath"
            :alt="item.name"
            rounded
            width="125px"
          />
          <b-img
          v-else
            :src="item.place_image"
            :alt="item.name"
            rounded
            width="125px"
          />
        </template>
        <feather-icon
          icon="XIcon"
          class="cart-item-remove cursor-pointer"
          @click.stop="removeItemFromCart(item.id)"
        />
        <div >
          <h6 class="cart-item-title">
            <b-link class="text-body">
              {{ item.place_name[currentLocale] }}
            </b-link>
          </h6>
          <small class="cart-item-by">
           {{  item.bedroom }} Bedroom  {{  item.sqm }} sqm. {{  item.floors }} Floor
          </small>
          <div class="mt-25">
            <small v-if="item.rent_price > 0" class="d-block text-primary font-weight-bold">
              Rent: ฿{{ parseFloat(item.rent_price).toLocaleString('en-US') }}/mo
            </small>
            <small v-if="item.sale_price > 0" class="d-block text-success font-weight-bold">
              Sale: ฿{{ parseFloat(item.sale_price).toLocaleString('en-US') }}
            </small>
          </div>
          <!-- <small class="cart-item-by">Owner: {{ item.owner_firstname }}</small> -->
        </div>

       

        <!-- <h5 class="cart-item-price">
          ${{ item.price }}
        </h5> -->
      </b-media>
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li
      v-if="items.length"
      class="dropdown-menu-footer"
    >
      <div class="d-flex justify-content-between mb-1">
        <!-- <h6 class="font-weight-bolder mb-0">
          Total:
        </h6>
        <h6 class="text-primary font-weight-bolder mb-0">
          ${{ totalAmount }}
        </h6> -->
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        :to="checkoutRoute"
      >
        {{ isCoAgent ? 'Submit Co-Agent Enquiry' : 'Add to Enquiry' }}
      </b-button>
    </li>

    <p
      v-if="!items.length"
      class="m-0 p-1 text-center"
    >
      Your Property is empty
    </p>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BImg, BFormSpinbutton, BButton,
} from 'bootstrap-vue'
;
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BImg,
    BFormSpinbutton,
    VuePerfectScrollbar,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      items: [],
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
    }
  },
  computed: {
    totalAmount() {
      let total = 0
      this.items.forEach(i => { total += i.price })
      return total
    },
    currentLocale() {
      return this.$i18n.locale
    },
    isCoAgent() {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      return userData.type_id === 5
    },
    checkoutRoute() {
      return this.isCoAgent
        ? { name: 'co-agent-enquiry-checkout' }
        : { name: 'enquiry-checkout', params: { checkout: true } }
    },
  },
  methods: {
    fetchItems() {
      this.$store.dispatch('app-p/fetchCartProducts')
        .then(response => {
          this.items = response.data.data || []
          this.$store.commit('app-p/UPDATE_CART_ITEMS_COUNT', this.items.length)
        })
    },
    removeItemFromCart(productId) {
      this.$store.dispatch('app-p/removeProductFromCart', { productId })
        .then(() => {
          const itemIndex = this.items.findIndex(p => p.id === productId)
          this.items.splice(itemIndex, 1)

          // Update count in cart items state
          this.$store.commit('app-p/UPDATE_CART_ITEMS_COUNT', this.items.length)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown-cart {
  .media {
    .media-aside {
      align-items: center;
    }
  }
}
</style>
